import OcrInterceptor from '../OcrInterceptor'
import { Template } from '../../../types/Ocr'

const api = new OcrInterceptor()

export default {
  addTemplate(template: Template) {
    return api.post(`/configuracao-templates`, template)
  },

  deleteTemplate(templateId: string) {
    return api.delete(`/configuracao-templates/${templateId}`)
  },

  getTemplate(templateId: string) {
    return api.get(`/configuracao-templates/${templateId}`)
  },

  getTemplateList() {
    return api.get(`/configuracao-templates`)
  },

  updateTemplate(template: Template) {
    return api.put(`/configuracao-templates/${template.id}`, template)
  },
}
